import React from "react";
import cx from "clsx";
import styles from "./styles.module.scss";
import { Box } from "../../../../shared/Box/Box";

export function PaymentLayout({ children }) {
  return (
    <div className={styles.root}>
      <Box className={styles.content}>{children}</Box>
    </div>
  );
}

PaymentLayout.Description = ({ children }) => (
  <div className={styles.description}>{children}</div>
);

/**
 * @param {{
 *    children: React.ReactNode;
 *    type: "success" | "failure";
 * }} param0
 */
PaymentLayout.Icon = ({ children, type }) => (
  <div
    className={cx(styles.icon, {
      [styles.iconSuccess]: type === "success",
      [styles.iconFailure]: type === "failure",
    })}
  >
    {children}
  </div>
);
